// GENERATED by packages/geo/pipeline/generate.ts from data/geo/seed/*.csv. Do not edit.
// GEO-001 dataset geo-2026.10.18-1; distribution: interim internal-use (licence unconfirmed; D-028).
// Sources, licences and checksums: data/geo/SOURCES.md and data/geo/seed/dataset.json.

export const DATASET = {
  version: "geo-2026.10.18-1",
  seedSha256: "bfff72f7d141c5d02f33385d3bfff843595e68f0e105dbb4ea7c1cf95a9e61a0",
  distribution: "interim internal-use (licence unconfirmed; D-028)",
  counts: {
    provinces: 7,
    districts: 77,
    local_levels: 753,
    wards: 6743,
    by_type: { metropolitan: 6, sub_metropolitan: 11, municipality: 276, rural_municipality: 460 },
  },
} as const;

/** [code, number, name_en, name_ne, hdx_pcode] */
export const PROVINCE_ROWS: readonly (readonly [string, number, string, string, string])[] = [
  ["P1", 1, "Koshi", "कोशी", "NP01"],
  ["P2", 2, "Madhesh", "मधेश", "NP02"],
  ["P3", 3, "Bagmati", "बागमती", "NP03"],
  ["P4", 4, "Gandaki", "गण्डकी", "NP04"],
  ["P5", 5, "Lumbini", "लुम्बिनी", "NP05"],
  ["P6", 6, "Karnali", "कर्णाली", "NP06"],
  ["P7", 7, "Sudur Paschim", "सुदूरपश्चिम", "NP07"],
];

/** [code, province_code, name_en, name_ne, hdx_pcode, aliases] */
export const DISTRICT_ROWS: readonly (readonly [
  string,
  string,
  string,
  string,
  string,
  readonly string[],
])[] = [
  ["D0101", "P1", "Taplejung", "ताप्लेजुङ", "NP0101", []],
  ["D0102", "P1", "Panchthar", "पाँचथर", "NP0102", []],
  ["D0103", "P1", "Ilam", "इलाम", "NP0103", []],
  ["D0104", "P1", "Jhapa", "झापा", "NP0104", []],
  ["D0105", "P1", "Morang", "मोरङ", "NP0105", []],
  ["D0106", "P1", "Sunsari", "सुनसरी", "NP0106", []],
  ["D0107", "P1", "Dhankuta", "धनकुटा", "NP0107", []],
  ["D0108", "P1", "Terhathum", "तेह्रथुम", "NP0108", []],
  ["D0109", "P1", "Sankhuwasabha", "संखुवासभा", "NP0109", []],
  ["D0110", "P1", "Bhojpur", "भोजपुर", "NP0110", []],
  ["D0111", "P1", "Solukhumbu", "सोलुखुम्बु", "NP0111", []],
  ["D0112", "P1", "Khotang", "खोटाङ", "NP0112", []],
  ["D0113", "P1", "Okhaldhunga", "ओखलढुंगा", "NP0113", []],
  ["D0114", "P1", "Udayapur", "उदयपुर", "NP0114", []],
  ["D0215", "P2", "Saptari", "सप्तरी", "NP0215", []],
  ["D0216", "P2", "Siraha", "सिराहा", "NP0216", []],
  ["D0217", "P2", "Dhanusa", "धनुषा", "NP0217", []],
  ["D0218", "P2", "Mahottari", "महोत्तरी", "NP0218", []],
  ["D0219", "P2", "Sarlahi", "सर्लाही", "NP0219", []],
  ["D0232", "P2", "Rautahat", "रौतहट", "NP0232", []],
  ["D0233", "P2", "Bara", "बारा", "NP0233", []],
  ["D0234", "P2", "Parsa", "पर्सा", "NP0234", []],
  ["D0320", "P3", "Sindhuli", "सिन्धुली", "NP0320", []],
  ["D0321", "P3", "Ramechhap", "रामेछाप", "NP0321", []],
  ["D0322", "P3", "Dolakha", "दोलखा", "NP0322", []],
  ["D0323", "P3", "Sindhupalchok", "सिन्धुपाल्चोक", "NP0323", []],
  ["D0324", "P3", "Kavrepalanchok", "काभ्रेपलाञ्चोक", "NP0324", []],
  ["D0325", "P3", "Lalitpur", "ललितपुर", "NP0325", []],
  ["D0326", "P3", "Bhaktapur", "भक्तपुर", "NP0326", []],
  ["D0327", "P3", "Kathmandu", "काठमाण्डौं", "NP0327", []],
  ["D0328", "P3", "Nuwakot", "नुवाकोट", "NP0328", []],
  ["D0329", "P3", "Rasuwa", "रसुवा", "NP0329", []],
  ["D0330", "P3", "Dhading", "धादिङ", "NP0330", []],
  ["D0331", "P3", "Makwanpur", "मकवानपुर", "NP0331", []],
  ["D0335", "P3", "Chitawan", "चितवन", "NP0335", []],
  ["D0436", "P4", "Gorkha", "गोरखा", "NP0436", []],
  ["D0437", "P4", "Lamjung", "लमजुङ", "NP0437", []],
  ["D0438", "P4", "Manang", "मनाङ", "NP0438", []],
  ["D0439", "P4", "Kaski", "कास्की", "NP0439", []],
  ["D0440", "P4", "Tanahu", "तनहुँ", "NP0440", []],
  ["D0441", "P4", "Syangja", "स्याङजा", "NP0441", []],
  ["D0442", "P4", "Parbat", "पर्वत", "NP0442", []],
  ["D0443", "P4", "Baglung", "बाग्लुङ", "NP0443", []],
  ["D0444", "P4", "Myagdi", "म्याग्दी", "NP0444", []],
  ["D0445", "P4", "Mustang", "मुस्ताङ", "NP0445", []],
  ["D0447", "P4", "Nawalparasi East", "नवलपरासी (बर्दघाट सुस्ता पूर्व)", "NP0447", []],
  ["D0546", "P5", "Palpa", "पाल्पा", "NP0546", []],
  ["D0547", "P5", "Nawalparasi West", "नवलपरासी (बर्दघाट सुस्ता पश्चिम)", "NP0547", []],
  ["D0548", "P5", "Rupandehi", "रूपन्देही", "NP0548", []],
  ["D0549", "P5", "Kapilbastu", "कपिलबस्तु", "NP0549", []],
  ["D0550", "P5", "Arghakhanchi", "अर्घाखाँची", "NP0550", []],
  ["D0551", "P5", "Gulmi", "गुल्मी", "NP0551", []],
  ["D0552", "P5", "Rukum East", "रुकुम (पूर्वी भाग)", "NP0552", []],
  ["D0554", "P5", "Rolpa", "रोल्पा", "NP0554", []],
  ["D0555", "P5", "Pyuthan", "प्यूठान", "NP0555", []],
  ["D0556", "P5", "Dang", "दाङ", "NP0556", []],
  ["D0557", "P5", "Banke", "बाँके", "NP0557", []],
  ["D0558", "P5", "Bardiya", "बर्दिया", "NP0558", []],
  ["D0652", "P6", "Rukum West", "रुकुम (पश्चिम भाग)", "NP0652", []],
  ["D0653", "P6", "Salyan", "सल्यान", "NP0653", []],
  ["D0659", "P6", "Surkhet", "सुर्खेत", "NP0659", []],
  ["D0660", "P6", "Jajarkot", "जाजरकोट", "NP0660", []],
  ["D0661", "P6", "Dailekh", "दैलेख", "NP0661", []],
  ["D0662", "P6", "Dolpa", "डोल्पा", "NP0662", []],
  ["D0663", "P6", "Jumla", "जुम्ला", "NP0663", []],
  ["D0664", "P6", "Kalikot", "कालिकोट", "NP0664", []],
  ["D0665", "P6", "Mugu", "मुगु", "NP0665", []],
  ["D0666", "P6", "Humla", "हुम्ला", "NP0666", []],
  ["D0767", "P7", "Bajhang", "बझाङ", "NP0767", []],
  ["D0768", "P7", "Bajura", "बाजुरा", "NP0768", []],
  ["D0769", "P7", "Achham", "अछाम", "NP0769", []],
  ["D0770", "P7", "Doti", "डोटी", "NP0770", []],
  ["D0771", "P7", "Kailali", "कैलाली", "NP0771", []],
  ["D0772", "P7", "Kanchanpur", "कञ्चनपुर", "NP0772", []],
  ["D0773", "P7", "Dadeldhura", "डडेल्धुरा", "NP0773", []],
  ["D0774", "P7", "Baitadi", "बैतडी", "NP0774", []],
  ["D0775", "P7", "Darchula", "दार्चुला", "NP0775", []],
];

/** [code, district_code, type index (metropolitan, sub_metropolitan, municipality, rural_municipality), name_en, name_ne, ward_count, hdx_pcode, in_kathmandu_valley (0|1), aliases] */
export const LOCAL_LEVEL_ROWS: readonly (readonly [
  string,
  string,
  number,
  string,
  string,
  number,
  string,
  number,
  readonly string[],
])[] = [
  ["L0101301", "D0101", 2, "Phungling", "फुङलिङ", 11, "NP0101301", 0, []],
  ["L0101401", "D0101", 3, "Phaktanlung", "फक्ताङलुङ", 7, "NP0101401", 0, []],
  ["L0101402", "D0101", 3, "Mikwakhola", "मिक्वाखोला", 5, "NP0101402", 0, []],
  ["L0101403", "D0101", 3, "Sirijanga", "सिरीजङ्घा", 8, "NP0101403", 0, []],
  ["L0101404", "D0101", 3, "Meringden", "मेरिङदेन", 6, "NP0101404", 0, []],
  ["L0101405", "D0101", 3, "Maiwakhola", "मैवाखोला", 6, "NP0101405", 0, []],
  ["L0101406", "D0101", 3, "Aatharai Tribeni", "आठराई त्रिवेणी", 5, "NP0101406", 0, []],
  ["L0101407", "D0101", 3, "Pathivara Yangwarak", "पाथिभरा याङ्वरक", 6, "NP0101407", 0, []],
  ["L0101408", "D0101", 3, "Sidingba", "सिदिङ्वा", 7, "NP0101408", 0, []],
  ["L0102301", "D0102", 2, "Phidim", "फिदिम", 14, "NP0102301", 0, []],
  ["L0102401", "D0102", 3, "Hilihan", "हिलिहाङ", 7, "NP0102401", 0, []],
  ["L0102402", "D0102", 3, "Yangbarak", "याङवरक", 6, "NP0102402", 0, []],
  ["L0102403", "D0102", 3, "Falelung", "फालेलुङ", 8, "NP0102403", 0, []],
  ["L0102404", "D0102", 3, "Kummayak", "कुम्मायक", 5, "NP0102404", 0, []],
  ["L0102405", "D0102", 3, "Falgunanda", "फाल्गुनन्द", 7, "NP0102405", 0, []],
  ["L0102406", "D0102", 3, "Tumbewa", "तुम्वेवा", 5, "NP0102406", 0, []],
  ["L0102407", "D0102", 3, "Miklajung", "मिक्लाजुङ", 8, "NP0102407", 0, []],
  ["L0103301", "D0103", 2, "Deumai", "देउमाई", 9, "NP0103301", 0, []],
  ["L0103302", "D0103", 2, "Illam", "ईलाम", 12, "NP0103302", 0, []],
  ["L0103303", "D0103", 2, "Suryodaya", "सुर्योदय", 14, "NP0103303", 0, []],
  ["L0103304", "D0103", 2, "Mai", "माई", 10, "NP0103304", 0, []],
  ["L0103401", "D0103", 3, "Fakfokathum", "फाकफोकथुम", 7, "NP0103401", 0, []],
  ["L0103402", "D0103", 3, "Sandakpur", "सन्दकपुर", 5, "NP0103402", 0, []],
  ["L0103403", "D0103", 3, "Mai Jogmai", "माईजोगमाई", 6, "NP0103403", 0, []],
  ["L0103404", "D0103", 3, "Chulachuli", "चुलाचुली", 6, "NP0103404", 0, []],
  ["L0103405", "D0103", 3, "Mangsebung", "माङसेबुङ", 6, "NP0103405", 0, []],
  ["L0103406", "D0103", 3, "Rong", "रोङ", 6, "NP0103406", 0, []],
  ["L0104301", "D0104", 2, "Damak", "दमक", 10, "NP0104301", 0, []],
  ["L0104302", "D0104", 2, "Shivasatakshi", "शिवसताक्षी", 11, "NP0104302", 0, []],
  ["L0104303", "D0104", 2, "Kankai", "कन्काई", 9, "NP0104303", 0, []],
  ["L0104304", "D0104", 2, "Arjundhara", "अर्जुनधारा", 11, "NP0104304", 0, []],
  ["L0104305", "D0104", 2, "Mechinagar", "मेचीनगर", 15, "NP0104305", 0, []],
  ["L0104306", "D0104", 2, "Gauradaha", "गौरादह", 9, "NP0104306", 0, []],
  ["L0104307", "D0104", 2, "Birtamod", "विर्तामोड", 10, "NP0104307", 0, []],
  ["L0104308", "D0104", 2, "Bhadrapur", "भद्रपुर", 10, "NP0104308", 0, []],
  ["L0104401", "D0104", 3, "Kamal", "कमल", 7, "NP0104401", 0, []],
  ["L0104402", "D0104", 3, "Buddhashanti", "बुद्धशान्ति", 7, "NP0104402", 0, []],
  ["L0104403", "D0104", 3, "Gauriganj", "गौरीगञ्ज", 6, "NP0104403", 0, []],
  ["L0104404", "D0104", 3, "Jhapa", "झापा", 7, "NP0104404", 0, []],
  ["L0104405", "D0104", 3, "Barhadashi", "बाह्रदशी", 7, "NP0104405", 0, []],
  ["L0104406", "D0104", 3, "Haldibari", "हल्दिबारी", 5, "NP0104406", 0, []],
  ["L0104407", "D0104", 3, "Kachanakawal", "कचनकवल", 7, "NP0104407", 0, []],
  ["L0105101", "D0105", 0, "Biratnagar", "विराटनगर", 19, "NP0105101", 0, []],
  ["L0105301", "D0105", 2, "Letang", "लेटाङ", 9, "NP0105301", 0, []],
  ["L0105302", "D0105", 2, "Sundarharaicha", "सुन्दर हरैचा", 12, "NP0105302", 0, []],
  ["L0105303", "D0105", 2, "Belbari", "बेलवारी", 11, "NP0105303", 0, []],
  ["L0105304", "D0105", 2, "Pathari Shanishchare", "पथरी शनिश्चरे", 10, "NP0105304", 0, []],
  ["L0105305", "D0105", 2, "Urlabari", "उर्लाबारी", 9, "NP0105305", 0, []],
  ["L0105306", "D0105", 2, "Rangeli", "रंगेली", 9, "NP0105306", 0, []],
  ["L0105307", "D0105", 2, "Sunwarshi", "सुनवर्षी", 9, "NP0105307", 0, []],
  ["L0105308", "D0105", 2, "Ratuwamai", "रतुवामाई", 10, "NP0105308", 0, []],
  ["L0105401", "D0105", 3, "Kerabari", "", 10, "NP0105401", 0, []],
  ["L0105402", "D0105", 3, "Miklajung", "मिक्लाजुङ", 9, "NP0105402", 0, []],
  ["L0105403", "D0105", 3, "Kanepokhari", "कानेपोखरी", 7, "NP0105403", 0, []],
  ["L0105404", "D0105", 3, "Budhiganga", "बुढीगंगा", 7, "NP0105404", 0, []],
  ["L0105405", "D0105", 3, "Gramthan", "ग्रामथान", 7, "NP0105405", 0, []],
  ["L0105406", "D0105", 3, "Katahari", "कटहरी", 7, "NP0105406", 0, []],
  ["L0105407", "D0105", 3, "Jahada", "जहदा", 7, "NP0105407", 0, []],
  ["L0105408", "D0105", 3, "Dhanapalthan", "धनपालथान", 7, "NP0105408", 0, []],
  ["L0106201", "D0106", 1, "Dharan", "", 20, "NP0106201", 0, []],
  ["L0106202", "D0106", 1, "Itahari", "", 20, "NP0106202", 0, []],
  ["L0106301", "D0106", 2, "Barahachhetra", "बराहक्षेत्र", 11, "NP0106301", 0, []],
  ["L0106302", "D0106", 2, "Ramdhuni", "रामधुनी", 9, "NP0106302", 0, []],
  ["L0106303", "D0106", 2, "Inaruwa", "इनरुवा", 10, "NP0106303", 0, []],
  ["L0106304", "D0106", 2, "Duhabi", "दुहवी", 12, "NP0106304", 0, []],
  ["L0106401", "D0106", 3, "Koshi", "कोशी", 8, "NP0106401", 0, []],
  ["L0106402", "D0106", 3, "Bhokraha Narsingh", "भोक्राहा नरसिंह", 8, "NP0106402", 0, []],
  ["L0106403", "D0106", 3, "Gadhi", "गढी", 6, "NP0106403", 0, []],
  ["L0106404", "D0106", 3, "Harinagar", "हरिनगर", 7, "NP0106404", 0, []],
  ["L0106405", "D0106", 3, "Dewangunj", "देवानगञ्ज", 7, "NP0106405", 0, []],
  ["L0106406", "D0106", 3, "Barju", "बर्जु", 6, "NP0106406", 0, []],
  ["L0107301", "D0107", 2, "Mahalaxmi", "महालक्ष्मी", 9, "NP0107301", 0, []],
  ["L0107302", "D0107", 2, "Pakhribas", "पाख्रिवास", 10, "NP0107302", 0, []],
  ["L0107303", "D0107", 2, "Dhankuta", "धनकुटा", 10, "NP0107303", 0, []],
  ["L0107401", "D0107", 3, "Shahidbhumi", "सहिदभुमि", 7, "NP0107401", 0, []],
  ["L0107402", "D0107", 3, "Chhathar Jorpati", "", 6, "NP0107402", 0, []],
  ["L0107403", "D0107", 3, "Sangurigadhi", "साँगुरीगढी", 10, "NP0107403", 0, []],
  ["L0107404", "D0107", 3, "Chaubise", "चौबिसे", 8, "NP0107404", 0, []],
  ["L0108301", "D0108", 2, "Laligurans", "लालीगुराँस", 9, "NP0108301", 0, []],
  ["L0108302", "D0108", 2, "Myanglung", "म्याङलुङ", 10, "NP0108302", 0, []],
  ["L0108401", "D0108", 3, "Menchhayayem", "मेन्छयायेम", 6, "NP0108401", 0, []],
  ["L0108402", "D0108", 3, "Phedap", "फेदाप", 5, "NP0108402", 0, []],
  ["L0108403", "D0108", 3, "Aatharai", "आठराई", 7, "NP0108403", 0, []],
  ["L0108404", "D0108", 3, "Chhathar", "छथर", 6, "NP0108404", 0, []],
  ["L0109301", "D0109", 2, "Khandabari", "खाँदवारी", 11, "NP0109301", 0, []],
  ["L0109302", "D0109", 2, "Panchakhapan", "पाँचखपन", 9, "NP0109302", 0, []],
  ["L0109303", "D0109", 2, "Chainapur", "", 11, "NP0109303", 0, []],
  ["L0109304", "D0109", 2, "Dharmadevi", "धर्मदेवी", 9, "NP0109304", 0, []],
  ["L0109305", "D0109", 2, "Madi", "मादी", 9, "NP0109305", 0, []],
  ["L0109401", "D0109", 3, "Makalu", "मकालु", 6, "NP0109401", 0, []],
  ["L0109402", "D0109", 3, "Bhotkhola", "भोटखोला", 5, "NP0109402", 0, []],
  ["L0109403", "D0109", 3, "Silichong", "सिलीचोङ", 5, "NP0109403", 0, []],
  ["L0109404", "D0109", 3, "Chichila", "चिचिला", 5, "NP0109404", 0, []],
  ["L0109405", "D0109", 3, "Sabhapokhari", "सभापोखरी", 6, "NP0109405", 0, []],
  ["L0110301", "D0110", 2, "Shadananda", "षडानन्द", 14, "NP0110301", 0, []],
  ["L0110302", "D0110", 2, "Bhojpur", "भोजपुर", 12, "NP0110302", 0, []],
  ["L0110401", "D0110", 3, "Salpa Silichho", "साल्पासिलिछो", 6, "NP0110401", 0, []],
  ["L0110402", "D0110", 3, "Temkemaiyum", "टेम्केमैयुङ", 9, "NP0110402", 0, []],
  ["L0110403", "D0110", 3, "Arun", "अरुण", 7, "NP0110403", 0, []],
  ["L0110404", "D0110", 3, "Ramprasad Rai", "रामप्रसाद राई", 8, "NP0110404", 0, []],
  ["L0110405", "D0110", 3, "Pauwa Dunma", "पौवादुङ्मा", 6, "NP0110405", 0, []],
  ["L0110406", "D0110", 3, "Aamchowk", "आमचोक", 10, "NP0110406", 0, []],
  ["L0110407", "D0110", 3, "Hatuwagadhi", "हतुवागढी", 9, "NP0110407", 0, []],
  ["L0111301", "D0111", 2, "Solu Dhudhakunda", "सोलुदुधकुण्ड", 11, "NP0111301", 0, []],
  ["L0111401", "D0111", 3, "Khumbu Pasanglhamu", "खुम्वु पासाङल्हामु", 5, "NP0111401", 0, []],
  ["L0111402", "D0111", 3, "Mahakulung", "माहाकुलुङ", 5, "NP0111402", 0, []],
  ["L0111403", "D0111", 3, "Likhu Pike", "लिखु पिके", 5, "NP0111403", 0, []],
  ["L0111404", "D0111", 3, "Mapya Dudhkoshi", "माप्य दुधकोशी", 7, "NP0111404", 0, []],
  ["L0111405", "D0111", 3, "Necha Salyan", "नेचासल्यान", 5, "NP0111405", 0, []],
  ["L0111406", "D0111", 3, "Thulung Dudhkoshi", "थुलुङ दुधकोशी", 9, "NP0111406", 0, []],
  ["L0111407", "D0111", 3, "Sotang", "सोताङ", 5, "NP0111407", 0, []],
  ["L0112301", "D0112", 2, "Halesi Tuwachung", "हलेसी तुवाचुङ", 11, "NP0112301", 0, []],
  [
    "L0112302",
    "D0112",
    2,
    "Diktel Rupakot Majhuwagadhi",
    "दिक्तेल रुपाकोट मझुवागढी",
    15,
    "NP0112302",
    0,
    [],
  ],
  ["L0112401", "D0112", 3, "Aiselukharka", "ऐसेलुखर्क", 7, "NP0112401", 0, []],
  ["L0112402", "D0112", 3, "Kepilasgadhi", "केपिलासगढी", 7, "NP0112402", 0, []],
  ["L0112403", "D0112", 3, "Rawa Besi", "रावा वेसी", 6, "NP0112403", 0, []],
  ["L0112404", "D0112", 3, "Diprung Chuichumma", "", 7, "NP0112404", 0, []],
  ["L0112405", "D0112", 3, "Sakela", "साकेला", 5, "NP0112405", 0, []],
  ["L0112406", "D0112", 3, "Khotehang", "खोटेहाङ", 9, "NP0112406", 0, []],
  ["L0112407", "D0112", 3, "Baraha Pokhari", "वराहपोखरी", 6, "NP0112407", 0, []],
  ["L0112408", "D0112", 3, "Jante Dhunga", "", 6, "NP0112408", 0, []],
  ["L0113301", "D0113", 2, "Siddhicharan", "सिद्धिचरण", 12, "NP0113301", 0, []],
  ["L0113401", "D0113", 3, "Khiji Demba", "खिजीदेम्वा", 9, "NP0113401", 0, []],
  ["L0113402", "D0113", 3, "Likhu", "लिखु", 9, "NP0113402", 0, []],
  ["L0113403", "D0113", 3, "Molung", "मोलुङ", 8, "NP0113403", 0, []],
  ["L0113404", "D0113", 3, "Champadevi", "चम्पादेवी", 10, "NP0113404", 0, []],
  ["L0113405", "D0113", 3, "Sunkoshi", "सुनकोशी", 10, "NP0113405", 0, []],
  ["L0113406", "D0113", 3, "Chishankhu Gadhi", "चिशंखुगढी", 8, "NP0113406", 0, []],
  ["L0113407", "D0113", 3, "Manebhanjyang", "मानेभञ्याङ", 9, "NP0113407", 0, []],
  ["L0114301", "D0114", 2, "Katari", "कटारी", 14, "NP0114301", 0, []],
  ["L0114302", "D0114", 2, "Triyuga", "त्रियुगा", 16, "NP0114302", 0, []],
  ["L0114303", "D0114", 2, "Chaudandigadhi", "चौदण्डीगढी", 10, "NP0114303", 0, []],
  ["L0114304", "D0114", 2, "Belaka", "वेलका", 9, "NP0114304", 0, []],
  ["L0114401", "D0114", 3, "Tapli", "ताप्ली", 5, "NP0114401", 0, []],
  ["L0114402", "D0114", 3, "Limchunbung", "लिम्चुङबुङ", 5, "NP0114402", 0, []],
  ["L0114403", "D0114", 3, "Udayapurgadhi", "उदयपुरगढी", 8, "NP0114403", 0, []],
  ["L0114404", "D0114", 3, "Rautamai", "रौतामाई", 8, "NP0114404", 0, []],
  ["L0215301", "D0215", 2, "Surunga", "सुरुगां", 11, "NP0215301", 0, []],
  ["L0215302", "D0215", 2, "Khadak", "खडक", 11, "NP0215302", 0, []],
  ["L0215303", "D0215", 2, "Shambhunath", "शम्भुनाथ", 12, "NP0215303", 0, []],
  ["L0215304", "D0215", 2, "Saptakoshi", "सप्तकोशी", 11, "NP0215304", 0, []],
  ["L0215305", "D0215", 2, "Kanchanrup", "कञ्चनरुप", 12, "NP0215305", 0, []],
  ["L0215306", "D0215", 2, "Bode Barsain", "बोदेबरसाईन", 10, "NP0215306", 0, []],
  ["L0215307", "D0215", 2, "Dakneshwori", "डाक्नेश्वरी", 10, "NP0215307", 0, []],
  ["L0215308", "D0215", 2, "Rajbiraj", "राजविराज", 16, "NP0215308", 0, []],
  ["L0215309", "D0215", 2, "Hanumannagar Kankalini", "हनुमाननगर कंकालिनी", 14, "NP0215309", 0, []],
  ["L0215401", "D0215", 3, "Rupani", "रुपनी", 6, "NP0215401", 0, []],
  [
    "L0215402",
    "D0215",
    3,
    "Agnisair Krishna Sabaran",
    "अग्नीसाइर कृष्णासवरन",
    6,
    "NP0215402",
    0,
    [],
  ],
  ["L0215403", "D0215", 3, "Tirahut", "तिरहुत", 5, "NP0215403", 0, []],
  ["L0215404", "D0215", 3, "Balan-Bihul", "बलान-विहुल", 6, "NP0215404", 0, []],
  ["L0215405", "D0215", 3, "Mahadewa", "महादेवा", 6, "NP0215405", 0, []],
  ["L0215406", "D0215", 3, "Rajgadh", "राजगढ", 6, "NP0215406", 0, []],
  ["L0215407", "D0215", 3, "Bishnupur", "बिष्णुपुर", 7, "NP0215407", 0, []],
  ["L0215408", "D0215", 3, "Chhinnamasta", "छिन्नमस्ता", 7, "NP0215408", 0, []],
  ["L0215409", "D0215", 3, "Tilathi Koiladi", "तिलाठीकोईलाडी", 8, "NP0215409", 0, []],
  ["L0216301", "D0216", 2, "Karjanha", "कर्जन्हा", 11, "NP0216301", 0, []],
  ["L0216302", "D0216", 2, "Mirchaiya", "मिर्चैया", 12, "NP0216302", 0, []],
  ["L0216303", "D0216", 2, "Golbazar", "गोलबजार", 13, "NP0216303", 0, []],
  ["L0216304", "D0216", 2, "Dhangadhimai", "धनगढीमाई", 14, "NP0216304", 0, []],
  ["L0216305", "D0216", 2, "Lahan", "लहान", 24, "NP0216305", 0, []],
  ["L0216306", "D0216", 2, "Kalyanpur", "कल्याणपुर", 12, "NP0216306", 0, []],
  ["L0216307", "D0216", 2, "Sukhipur", "सुखीपुर", 10, "NP0216307", 0, []],
  ["L0216308", "D0216", 2, "Siraha", "सिरहा", 22, "NP0216308", 0, []],
  ["L0216401", "D0216", 3, "Naraha", "नरहा", 5, "NP0216401", 0, []],
  ["L0216402", "D0216", 3, "Bishnupur", "विष्णुपुर", 5, "NP0216402", 0, []],
  ["L0216403", "D0216", 3, "Arnama", "अर्नमा", 5, "NP0216403", 0, []],
  ["L0216404", "D0216", 3, "Aurahi", "औरही", 5, "NP0216404", 0, []],
  ["L0216405", "D0216", 3, "Bariyarpatti", "बरियारपट्टी", 5, "NP0216405", 0, []],
  ["L0216406", "D0216", 3, "Laxmipur Patari", "लक्ष्मीपुर पतारी", 6, "NP0216406", 0, []],
  ["L0216407", "D0216", 3, "Nawarajpur", "नवराजपुर", 5, "NP0216407", 0, []],
  ["L0216408", "D0216", 3, "Sakhuwa Nankarkatti", "सखुवानान्कारकट्टी", 5, "NP0216408", 0, []],
  ["L0216409", "D0216", 3, "Bhagawanpur", "भगवानपुर", 5, "NP0216409", 0, []],
  ["L0217201", "D0217", 1, "Janakpurdham", "जनकपुर", 25, "NP0217201", 0, []],
  ["L0217301", "D0217", 2, "Mithila", "मिथिला", 11, "NP0217301", 0, []],
  ["L0217302", "D0217", 2, "Ganeshman Charnath", "गणेशमान–चारनाथ", 11, "NP0217302", 0, []],
  ["L0217303", "D0217", 2, "Chhireshwornath", "क्षिरेश्वरनाथ", 10, "NP0217303", 0, []],
  ["L0217304", "D0217", 2, "Dhanushadham", "धनुषाधाम", 9, "NP0217304", 0, []],
  ["L0217305", "D0217", 2, "Mithila Bihari", "मिथिला विहारी", 10, "NP0217305", 0, []],
  ["L0217306", "D0217", 2, "Sabaila", "सबैला", 13, "NP0217306", 0, []],
  ["L0217307", "D0217", 2, "Hansapur", "हंसपुर", 9, "NP0217307", 0, []],
  ["L0217308", "D0217", 2, "Shahidnagar", "शहिदनगर", 9, "NP0217308", 0, []],
  ["L0217309", "D0217", 2, "Nagarain", "नगराइन", 9, "NP0217309", 0, []],
  ["L0217310", "D0217", 2, "Bideha", "विदेह", 9, "NP0217310", 0, []],
  ["L0217311", "D0217", 2, "Kamala", "कमला", 9, "NP0217311", 0, []],
  ["L0217401", "D0217", 3, "Bateshwor", "बटेश्वर", 5, "NP0217401", 0, []],
  ["L0217402", "D0217", 3, "Laxminiya", "लक्ष्मीनिया", 7, "NP0217402", 0, []],
  ["L0217403", "D0217", 3, "Aurahi", "औरही", 6, "NP0217403", 0, []],
  ["L0217404", "D0217", 3, "Dhanauji", "धनौजी", 5, "NP0217404", 0, []],
  [
    "L0217405",
    "D0217",
    3,
    "Mukhiyapatti Musaharmiya",
    "मुखियापट्टि मुसहरमिया",
    6,
    "NP0217405",
    0,
    [],
  ],
  ["L0217406", "D0217", 3, "Janak Nandini", "जनकनन्दिनी", 6, "NP0217406", 0, []],
  ["L0218301", "D0218", 2, "Bardibas", "बर्दिबास", 14, "NP0218301", 0, []],
  ["L0218302", "D0218", 2, "Gaushala", "गौशाला", 12, "NP0218302", 0, []],
  ["L0218303", "D0218", 2, "Aurahi", "औरही", 9, "NP0218303", 0, []],
  ["L0218304", "D0218", 2, "Bhangaha", "भँगाहा", 9, "NP0218304", 0, []],
  ["L0218305", "D0218", 2, "Ram Gopalpur", "रामगोपालपुर", 9, "NP0218305", 0, []],
  ["L0218306", "D0218", 2, "Manara Shisawa", "मनरा सिसवा", 10, "NP0218306", 0, []],
  ["L0218307", "D0218", 2, "Balawa", "बलवा", 11, "NP0218307", 0, []],
  ["L0218308", "D0218", 2, "Loharpatti", "लोहरपट्टी", 9, "NP0218308", 0, []],
  ["L0218309", "D0218", 2, "Jaleshwor", "जलेश्वर", 12, "NP0218309", 0, []],
  ["L0218310", "D0218", 2, "Matihani", "मटिहानी", 9, "NP0218310", 0, []],
  ["L0218401", "D0218", 3, "Sonama", "सोनमा", 8, "NP0218401", 0, []],
  ["L0218402", "D0218", 3, "Samsi", "साम्सी", 7, "NP0218402", 0, []],
  ["L0218403", "D0218", 3, "Ekadara", "एकडारा", 6, "NP0218403", 0, []],
  ["L0218404", "D0218", 3, "Mahottari", "महोत्तरी", 6, "NP0218404", 0, []],
  ["L0218405", "D0218", 3, "Pipara", "पिपरा", 7, "NP0218405", 0, []],
  ["L0219301", "D0219", 2, "Bagmati", "बागमती", 12, "NP0219301", 0, []],
  ["L0219302", "D0219", 2, "Hariwan", "हरिवन", 11, "NP0219302", 0, []],
  ["L0219303", "D0219", 2, "Lalbandi", "लालबन्दी", 17, "NP0219303", 0, []],
  ["L0219304", "D0219", 2, "Barahathawa", "बरहथवा", 18, "NP0219304", 0, []],
  ["L0219305", "D0219", 2, "Haripur", "हरिपुर", 9, "NP0219305", 0, []],
  ["L0219306", "D0219", 2, "Ishworpur", "ईश्वरपुर", 15, "NP0219306", 0, []],
  ["L0219307", "D0219", 2, "Kabilashi", "", 10, "NP0219307", 0, []],
  ["L0219308", "D0219", 2, "Godaita", "गोडैटा", 12, "NP0219308", 0, []],
  ["L0219309", "D0219", 2, "Malangawa", "मलंगवा", 12, "NP0219309", 0, []],
  ["L0219310", "D0219", 2, "Haripurwa", "हरिपुर्वा", 9, "NP0219310", 0, []],
  ["L0219311", "D0219", 2, "Balara", "बलरा", 11, "NP0219311", 0, []],
  ["L0219401", "D0219", 3, "Basbariya", "बसबरीया", 6, "NP0219401", 0, []],
  ["L0219402", "D0219", 3, "Chandranagar", "चन्द्रनगर", 7, "NP0219402", 0, []],
  ["L0219403", "D0219", 3, "Dhanakaul", "धनकौल", 7, "NP0219403", 0, []],
  ["L0219404", "D0219", 3, "Chakraghatta", "चक्रघट्टा", 9, "NP0219404", 0, []],
  ["L0219405", "D0219", 3, "Ramnagar", "रामनगर", 7, "NP0219405", 0, []],
  ["L0219406", "D0219", 3, "Kaudena", "कौडेना", 7, "NP0219406", 0, []],
  ["L0219407", "D0219", 3, "Brahmapuri", "ब्रह्मपुरी", 7, "NP0219407", 0, []],
  ["L0219408", "D0219", 3, "Bishnu", "विष्णु", 8, "NP0219408", 0, []],
  ["L0219409", "D0219", 3, "Parsa", "पर्सा", 6, "NP0219409", 0, []],
  ["L0232301", "D0232", 2, "Gujara", "गुजरा", 9, "NP0232301", 0, []],
  ["L0232302", "D0232", 2, "Chandrapur", "चन्द्रपुर", 10, "NP0232302", 0, []],
  ["L0232303", "D0232", 2, "Phatuwa Bijayapur", "फतुवा विजयपुर", 11, "NP0232303", 0, []],
  ["L0232304", "D0232", 2, "Katahariya", "कटहरीया", 9, "NP0232304", 0, []],
  ["L0232305", "D0232", 2, "Brindaban", "वृन्दावन", 9, "NP0232305", 0, []],
  ["L0232306", "D0232", 2, "Maulapur", "मौलापुर", 9, "NP0232306", 0, []],
  ["L0232307", "D0232", 2, "Dewahi Gonahi", "देवाही गोनाही", 9, "NP0232307", 0, []],
  ["L0232308", "D0232", 2, "Garuda", "गरुडा", 9, "NP0232308", 0, []],
  ["L0232309", "D0232", 2, "Gadhimai", "गढीमाई", 9, "NP0232309", 0, []],
  ["L0232310", "D0232", 2, "Boudhimai", "बौधीमाई", 9, "NP0232310", 0, []],
  ["L0232311", "D0232", 2, "Madhav Narayan", "माधवनारायण", 9, "NP0232311", 0, []],
  ["L0232312", "D0232", 2, "Paroha", "परोहा", 9, "NP0232312", 0, []],
  ["L0232313", "D0232", 2, "Ishanath", "ईशनाथ", 9, "NP0232313", 0, []],
  ["L0232314", "D0232", 2, "Rajpur", "राजपुर", 9, "NP0232314", 0, []],
  ["L0232315", "D0232", 2, "Gaur", "गौर", 9, "NP0232315", 0, []],
  ["L0232316", "D0232", 2, "Rajdevi", "राजदेवी", 9, "NP0232316", 0, []],
  ["L0232401", "D0232", 3, "Yamunamai", "यमुनामाई", 5, "NP0232401", 0, []],
  ["L0232402", "D0232", 3, "Durga Bhagawati", "दुर्गाभगवती", 5, "NP0232402", 0, []],
  ["L0233201", "D0233", 1, "Jitpur Simara", "जितपुर-सिमरा", 24, "NP0233201", 0, []],
  ["L0233202", "D0233", 1, "Kalaiya", "कलैया", 27, "NP0233202", 0, []],
  ["L0233301", "D0233", 2, "Nijagadh", "निजगढ", 13, "NP0233301", 0, []],
  ["L0233302", "D0233", 2, "Kolhabi", "कोल्हवी", 11, "NP0233302", 0, []],
  ["L0233303", "D0233", 2, "Mahagadhimai", "महागढीमाई", 11, "NP0233303", 0, []],
  ["L0233304", "D0233", 2, "Pacharauta", "पचरौता", 9, "NP0233304", 0, []],
  ["L0233305", "D0233", 2, "Simroungadh", "सिम्रौनगढ", 11, "NP0233305", 0, []],
  ["L0233401", "D0233", 3, "Parawanipur", "परवानीपुर", 5, "NP0233401", 0, []],
  ["L0233402", "D0233", 3, "Prasauni", "प्रसौनी", 7, "NP0233402", 0, []],
  ["L0233403", "D0233", 3, "Karaiyamai", "करैयामाई", 8, "NP0233403", 0, []],
  ["L0233404", "D0233", 3, "Bishrampur", "विश्रामपुर", 5, "NP0233404", 0, []],
  ["L0233405", "D0233", 3, "Pheta", "फेटा", 7, "NP0233405", 0, []],
  ["L0233406", "D0233", 3, "Baragadhi", "बारागढी", 6, "NP0233406", 0, []],
  ["L0233407", "D0233", 3, "Devtal", "देवताल", 7, "NP0233407", 0, []],
  ["L0233408", "D0233", 3, "Subarna", "सुवर्ण", 8, "NP0233408", 0, []],
  ["L0233409", "D0233", 3, "Aadarsha Kotwal", "आदर्श कोतवाल", 8, "NP0233409", 0, []],
  ["L0234101", "D0234", 0, "Birgunj", "वीरगञ्ज", 32, "NP0234101", 0, []],
  ["L0234301", "D0234", 2, "Pokhariya", "पोखरिया", 10, "NP0234301", 0, []],
  ["L0234302", "D0234", 2, "Bahudarmai", "बहुदरमाई", 9, "NP0234302", 0, []],
  ["L0234303", "D0234", 2, "Parsagadhi", "पर्सागढी", 9, "NP0234303", 0, []],
  ["L0234401", "D0234", 3, "Thori", "ठोरी", 5, "NP0234401", 0, []],
  ["L0234402", "D0234", 3, "Jirabhawani", "जिराभवानी", 5, "NP0234402", 0, []],
  ["L0234403", "D0234", 3, "Paterwa Sugauli", "पटेर्वा सुगौली", 5, "NP0234403", 0, []],
  ["L0234404", "D0234", 3, "Sakhuwa Prasauni", "सखुवा प्रसौनी", 6, "NP0234404", 0, []],
  ["L0234405", "D0234", 3, "Jagarnathpur", "जगरनाथपुर", 6, "NP0234405", 0, []],
  ["L0234406", "D0234", 3, "Dhobini", "धोबीनी", 5, "NP0234406", 0, []],
  ["L0234407", "D0234", 3, "Chhipaharmai", "छिपहरमाई", 5, "NP0234407", 0, []],
  ["L0234408", "D0234", 3, "Kalikamai", "कालिकामाई", 5, "NP0234408", 0, []],
  ["L0234409", "D0234", 3, "Pakaha Mainpur", "पकाहा मैनपुर", 5, "NP0234409", 0, []],
  ["L0234410", "D0234", 3, "Bindabasini", "बिन्दबासिनी", 5, "NP0234410", 0, []],
  ["L0320301", "D0320", 2, "Kamalamai", "कमलामाई", 14, "NP0320301", 0, []],
  ["L0320302", "D0320", 2, "Dudhouli", "दुधौली", 14, "NP0320302", 0, []],
  ["L0320401", "D0320", 3, "Hariharpurgaghi", "हरिहरपुरगढी", 8, "NP0320401", 0, []],
  ["L0320402", "D0320", 3, "Marin", "मरिण", 7, "NP0320402", 0, []],
  ["L0320403", "D0320", 3, "Ghyanglekha", "घ्याङलेख", 5, "NP0320403", 0, []],
  ["L0320404", "D0320", 3, "Sunkoshi", "सुनकोशी", 7, "NP0320404", 0, []],
  ["L0320405", "D0320", 3, "Golanjor", "गोलन्जोर", 7, "NP0320405", 0, []],
  ["L0320406", "D0320", 3, "Tinpatan", "तीनपाटन", 11, "NP0320406", 0, []],
  ["L0320407", "D0320", 3, "Phikkal", "फिक्कल", 6, "NP0320407", 0, []],
  ["L0321301", "D0321", 2, "Manthali", "मन्थली", 14, "NP0321301", 0, []],
  ["L0321302", "D0321", 2, "Ramechhap", "रामेछाप", 9, "NP0321302", 0, []],
  ["L0321401", "D0321", 3, "Sunapati", "सुनापति", 5, "NP0321401", 0, []],
  ["L0321402", "D0321", 3, "Doramba", "दोरम्बा शैलुङ", 7, "NP0321402", 0, []],
  ["L0321403", "D0321", 3, "Gokulganga", "गोकुलगङ्गा", 6, "NP0321403", 0, []],
  ["L0321404", "D0321", 3, "Umakunda", "उमाकुण्ड", 7, "NP0321404", 0, []],
  ["L0321405", "D0321", 3, "Khandadevi", "खाँडादेवी", 9, "NP0321405", 0, []],
  ["L0321406", "D0321", 3, "Likhu Tamakoshi", "लिखु तामाकोशी", 7, "NP0321406", 0, []],
  ["L0322301", "D0322", 2, "Bhimeshwor", "भिमेश्वर", 9, "NP0322301", 0, []],
  ["L0322302", "D0322", 2, "Jiri", "जिरी", 9, "NP0322302", 0, []],
  ["L0322401", "D0322", 3, "Bigu", "विगु", 8, "NP0322401", 0, []],
  ["L0322402", "D0322", 3, "Gaurishankar", "गौरीशङ्कर", 9, "NP0322402", 0, []],
  ["L0322403", "D0322", 3, "Kalinchowk", "कालिन्चोक", 9, "NP0322403", 0, []],
  ["L0322404", "D0322", 3, "Baiteshwor", "वैतेश्वर", 8, "NP0322404", 0, []],
  ["L0322405", "D0322", 3, "Shailung", "शैलुङ्ग", 8, "NP0322405", 0, []],
  ["L0322406", "D0322", 3, "Melung", "मेलुङ्ग", 7, "NP0322406", 0, []],
  ["L0322407", "D0322", 3, "Tamakoshi", "तामाकोशी", 7, "NP0322407", 0, []],
  ["L0323301", "D0323", 2, "Melamchi", "मेलम्ची", 13, "NP0323301", 0, ["Melanchi"]],
  ["L0323302", "D0323", 2, "Choutara Sangachowkgadhi", "चौतारा सागाचोकगढी", 14, "NP0323302", 0, []],
  ["L0323303", "D0323", 2, "Bahrabise", "वाह्रविसे", 9, "NP0323303", 0, []],
  ["L0323401", "D0323", 3, "Helambu", "हेलम्बु", 7, "NP0323401", 0, []],
  ["L0323402", "D0323", 3, "Panchpokhari Thangpal", "पाँचपोखरी थाङपाल", 8, "NP0323402", 0, []],
  ["L0323403", "D0323", 3, "Jugal", "जुगल", 7, "NP0323403", 0, []],
  ["L0323404", "D0323", 3, "Bhotekoshi", "भोटेकोशी", 5, "NP0323404", 0, []],
  ["L0323405", "D0323", 3, "Indrawoti", "ईन्द्रावती", 12, "NP0323405", 0, []],
  ["L0323406", "D0323", 3, "Balephi", "बलेफी", 8, "NP0323406", 0, []],
  ["L0323407", "D0323", 3, "Sunkoshi", "सुनकोशी", 7, "NP0323407", 0, []],
  ["L0323408", "D0323", 3, "Tripurasundari", "त्रिपुरासुन्दरी", 6, "NP0323408", 0, []],
  ["L0323409", "D0323", 3, "Lisankhu Pakhar", "लिसंखुपाखर", 7, "NP0323409", 0, []],
  ["L0324301", "D0324", 2, "Mandan Deupur", "मण्डनदेउपुर", 12, "NP0324301", 0, []],
  ["L0324302", "D0324", 2, "Banepa", "बनेपा", 14, "NP0324302", 0, []],
  ["L0324303", "D0324", 2, "Dhulikhel", "", 12, "NP0324303", 0, []],
  ["L0324304", "D0324", 2, "Panchkhal", "पांचखाल", 13, "NP0324304", 0, []],
  ["L0324305", "D0324", 2, "Panauti", "पनौती", 12, "NP0324305", 0, []],
  ["L0324306", "D0324", 2, "Namobuddha", "नमोबुद्ध", 11, "NP0324306", 0, []],
  ["L0324401", "D0324", 3, "Bhumlu", "भुम्लु", 10, "NP0324401", 0, []],
  ["L0324402", "D0324", 3, "Chauri Deurali", "चौंरीदेउराली", 9, "NP0324402", 0, []],
  ["L0324403", "D0324", 3, "Bethanchowk", "बेथानचोक", 6, "NP0324403", 0, []],
  ["L0324404", "D0324", 3, "Roshi", "रोशी", 12, "NP0324404", 0, []],
  ["L0324405", "D0324", 3, "Temal", "तेमाल", 9, "NP0324405", 0, []],
  ["L0324406", "D0324", 3, "Khanikhola", "खानीखोला", 7, "NP0324406", 0, []],
  ["L0324407", "D0324", 3, "Mahabharat", "महाभारत", 8, "NP0324407", 0, []],
  ["L0325101", "D0325", 0, "Lalitpur", "ललितपुर", 29, "NP0325101", 1, []],
  ["L0325301", "D0325", 2, "Godawari", "गोदावरी", 14, "NP0325301", 1, []],
  ["L0325302", "D0325", 2, "Mahalaxmi", "महालक्ष्मी", 10, "NP0325302", 1, []],
  ["L0325401", "D0325", 3, "Bagmati", "बाग्मती", 7, "NP0325401", 0, []],
  ["L0325402", "D0325", 3, "Konjyosom", "कोन्ज्योसोम", 5, "NP0325402", 0, []],
  ["L0325403", "D0325", 3, "Mahankal", "महाङ्काल", 6, "NP0325403", 0, []],
  ["L0326301", "D0326", 2, "Madhyapur Thimi", "मध्यपुर थिमी", 9, "NP0326301", 1, []],
  ["L0326302", "D0326", 2, "Changunarayan", "चाँगुनारायण", 9, "NP0326302", 1, []],
  ["L0326303", "D0326", 2, "Bhaktapur", "भक्तपुर", 10, "NP0326303", 1, []],
  ["L0326304", "D0326", 2, "Suryabinayak", "सूर्यविनायक", 10, "NP0326304", 1, []],
  ["L0327101", "D0327", 0, "Kathmandu", "काठमाण्डौं", 32, "NP0327101", 1, []],
  ["L0327301", "D0327", 2, "Tarakeshwor", "तारकेश्वर", 11, "NP0327301", 1, []],
  ["L0327302", "D0327", 2, "Tokha", "टोखा", 11, "NP0327302", 1, []],
  ["L0327303", "D0327", 2, "Budhanilkhantha", "बुढानिलकण्ठ", 13, "NP0327303", 1, []],
  ["L0327304", "D0327", 2, "Gokarneshwor", "गोकर्णेश्वर", 9, "NP0327304", 1, []],
  ["L0327305", "D0327", 2, "Nagarjun", "नागार्जुन", 10, "NP0327305", 1, []],
  ["L0327306", "D0327", 2, "Kageshwori Manahara", "कागेश्वरी–मनोहरा", 9, "NP0327306", 1, []],
  ["L0327307", "D0327", 2, "Shankharapur", "शंखरापुर", 9, "NP0327307", 1, []],
  ["L0327308", "D0327", 2, "Chandragiri", "चन्द्रागिरी", 15, "NP0327308", 1, []],
  ["L0327309", "D0327", 2, "Kirtipur", "कीर्तिपुर", 10, "NP0327309", 1, []],
  ["L0327310", "D0327", 2, "Dakshinkali", "दक्षिणकाली", 9, "NP0327310", 1, []],
  ["L0328301", "D0328", 2, "Bidur", "विदुर", 13, "NP0328301", 0, []],
  ["L0328302", "D0328", 2, "Belkotgadhi", "बेलकोटगढी", 13, "NP0328302", 0, []],
  ["L0328401", "D0328", 3, "Myagang", "म्यागङ", 6, "NP0328401", 0, []],
  ["L0328402", "D0328", 3, "Kispang", "किस्पाङ", 5, "NP0328402", 0, []],
  ["L0328403", "D0328", 3, "Tarakeshwor", "तारकेश्वर", 6, "NP0328403", 0, []],
  ["L0328404", "D0328", 3, "Suryagadhi", "सुर्यगढी", 5, "NP0328404", 0, []],
  ["L0328405", "D0328", 3, "Tadi", "तादी", 6, "NP0328405", 0, []],
  ["L0328406", "D0328", 3, "Likhu", "लिखु", 6, "NP0328406", 0, []],
  ["L0328407", "D0328", 3, "Panchakanya", "पञ्चकन्या", 5, "NP0328407", 0, []],
  ["L0328408", "D0328", 3, "Dupcheshwor", "दुप्चेश्वर", 7, "NP0328408", 0, []],
  ["L0328409", "D0328", 3, "Kakani", "ककनी", 8, "NP0328409", 0, []],
  ["L0328410", "D0328", 3, "Shivapuri", "शिवपुरी", 8, "NP0328410", 0, []],
  ["L0329401", "D0329", 3, "Aamachhodingmo", "आमाछोदिङमो", 5, "NP0329401", 0, []],
  ["L0329402", "D0329", 3, "Gosaikunda", "गोसाईंकुण्ड", 6, "NP0329402", 0, []],
  ["L0329403", "D0329", 3, "Uttargaya", "उत्तरगया", 5, "NP0329403", 0, []],
  ["L0329404", "D0329", 3, "Kalika", "कालिका", 5, "NP0329404", 0, []],
  ["L0329405", "D0329", 3, "Naukunda", "नौकुण्ड", 6, "NP0329405", 0, []],
  ["L0330301", "D0330", 2, "Nilkhantha", "नीलकण्ठ", 14, "NP0330301", 0, []],
  ["L0330302", "D0330", 2, "Dhunibenshi", "धुनीबेंसी", 9, "NP0330302", 0, []],
  ["L0330401", "D0330", 3, "Rubi Valley", "रुवी भ्याली", 6, "NP0330401", 0, []],
  ["L0330402", "D0330", 3, "Ganga Jamuna", "गङ्गाजमुना", 7, "NP0330402", 0, []],
  ["L0330403", "D0330", 3, "Khaniyabas", "खनियाबास", 5, "NP0330403", 0, []],
  ["L0330404", "D0330", 3, "Tripurasundari", "त्रिपुरासुन्दरी", 7, "NP0330404", 0, []],
  ["L0330405", "D0330", 3, "Netrawati Dabjong", "नेत्रावती डबजोङ", 5, "NP0330405", 0, []],
  ["L0330406", "D0330", 3, "Jwalamukhi", "ज्वालामूखी", 7, "NP0330406", 0, []],
  ["L0330407", "D0330", 3, "Siddhalek", "सिद्धलेक", 7, "NP0330407", 0, []],
  ["L0330408", "D0330", 3, "Benighat Rorang", "बेनीघाट रोराङ्ग", 10, "NP0330408", 0, []],
  ["L0330409", "D0330", 3, "Gajuri", "गजुरी", 8, "NP0330409", 0, []],
  ["L0330410", "D0330", 3, "Galchhi", "गल्छी", 8, "NP0330410", 0, []],
  ["L0330411", "D0330", 3, "Thakre", "थाक्रे", 11, "NP0330411", 0, []],
  ["L0331201", "D0331", 1, "Hetauda", "हेटौंडा", 19, "NP0331201", 0, []],
  ["L0331301", "D0331", 2, "Thaha", "थाहा", 12, "NP0331301", 0, []],
  ["L0331401", "D0331", 3, "Manahari", "मनहरी", 9, "NP0331401", 0, []],
  ["L0331402", "D0331", 3, "Raksirang", "राक्सिराङ्ग", 9, "NP0331402", 0, []],
  ["L0331403", "D0331", 3, "Kailash", "कैलाश", 10, "NP0331403", 0, []],
  ["L0331404", "D0331", 3, "Bhimphedi", "भिमफेदी", 9, "NP0331404", 0, []],
  ["L0331405", "D0331", 3, "Indrasarowar", "ईन्द्रसरोवर", 5, "NP0331405", 0, []],
  ["L0331406", "D0331", 3, "Makawanpurgadhi", "मकवानपुरगढी", 8, "NP0331406", 0, []],
  ["L0331407", "D0331", 3, "Bakaiya", "बकैया", 12, "NP0331407", 0, []],
  ["L0331408", "D0331", 3, "Bagmati", "बाग्मती", 9, "NP0331408", 0, []],
  ["L0335101", "D0335", 0, "Bharatpur", "भरतपुर", 29, "NP0335101", 0, []],
  ["L0335301", "D0335", 2, "Kalika", "कालिका", 11, "NP0335301", 0, []],
  ["L0335302", "D0335", 2, "Ratnanagar", "रत्ननगर", 16, "NP0335302", 0, []],
  ["L0335303", "D0335", 2, "Khairahani", "खैरहनी", 13, "NP0335303", 0, []],
  ["L0335304", "D0335", 2, "Rapti", "राप्ती", 13, "NP0335304", 0, []],
  ["L0335305", "D0335", 2, "Madi", "माडी", 9, "NP0335305", 0, []],
  ["L0335401", "D0335", 3, "Ichchha Kamana", "इच्छाकामना", 7, "NP0335401", 0, []],
  ["L0436301", "D0436", 2, "Palungtar", "पालुङटार", 10, "NP0436301", 0, []],
  ["L0436302", "D0436", 2, "Gorkha", "गोरखा", 14, "NP0436302", 0, []],
  ["L0436401", "D0436", 3, "Chumanubri", "चुमनुव्री", 7, "NP0436401", 0, []],
  ["L0436402", "D0436", 3, "Ajirkot", "अजिरकोट", 5, "NP0436402", 0, []],
  ["L0436403", "D0436", 3, "Barpak Sulikot", "बारपाक सुलिकोट", 8, "NP0436403", 0, []],
  ["L0436404", "D0436", 3, "Dharche", "धार्चे", 7, "NP0436404", 0, []],
  ["L0436405", "D0436", 3, "Siranchowk", "", 8, "NP0436405", 0, []],
  ["L0436406", "D0436", 3, "Aarughat", "आरूघाट", 10, "NP0436406", 0, []],
  ["L0436407", "D0436", 3, "Bhimsenthapa", "भिमसेनथापा", 8, "NP0436407", 0, []],
  ["L0436408", "D0436", 3, "Shahid Lakhan", "शहिद लखन", 9, "NP0436408", 0, []],
  ["L0436409", "D0436", 3, "Gandaki", "गण्डकी", 8, "NP0436409", 0, []],
  ["L0437301", "D0437", 2, "Madhya Nepal", "मध्यनेपाल", 10, "NP0437301", 0, []],
  ["L0437302", "D0437", 2, "Bensishahar", "बेसीशहर", 11, "NP0437302", 0, []],
  ["L0437303", "D0437", 2, "Sundarbazar", "सुन्दरबजार", 11, "NP0437303", 0, []],
  ["L0437304", "D0437", 2, "Rainas", "राईनास", 10, "NP0437304", 0, []],
  ["L0437401", "D0437", 3, "Kwhola Sothar", "क्व्होलासोथार", 9, "NP0437401", 0, []],
  ["L0437402", "D0437", 3, "Marshyangdi", "मर्स्याङदी", 9, "NP0437402", 0, []],
  ["L0437403", "D0437", 3, "Dordi", "दोर्दी", 9, "NP0437403", 0, []],
  ["L0437404", "D0437", 3, "Dudhapokhari", "दूधपोखरी", 6, "NP0437404", 0, []],
  ["L0438401", "D0438", 3, "Ngisyang", "मनाङ ङिस्याङ", 9, "NP0438401", 0, ["Manang Ngisyang"]],
  ["L0438402", "D0438", 3, "Narpa Bhumi", "नार्पा भूमि", 5, "NP0438402", 0, []],
  ["L0438403", "D0438", 3, "Chame", "चामे", 5, "NP0438403", 0, []],
  ["L0438404", "D0438", 3, "Nason", "नासोँ", 9, "NP0438404", 0, []],
  ["L0439101", "D0439", 0, "Pokhara", "पोखरा", 33, "NP0439101", 0, []],
  ["L0439401", "D0439", 3, "Annapurna", "", 11, "NP0439401", 0, []],
  ["L0439402", "D0439", 3, "Machhapuchchhre", "माछापुछ्रे", 9, "NP0439402", 0, []],
  ["L0439403", "D0439", 3, "Madi", "मादी", 12, "NP0439403", 0, []],
  ["L0439404", "D0439", 3, "Rupa", "रूपा", 7, "NP0439404", 0, []],
  ["L0440301", "D0440", 2, "Shuklagandaki", "शुक्लागण्डकी", 12, "NP0440301", 0, []],
  ["L0440302", "D0440", 2, "Byas", "व्यास", 14, "NP0440302", 0, []],
  ["L0440303", "D0440", 2, "Bhanu", "भानु", 13, "NP0440303", 0, []],
  ["L0440304", "D0440", 2, "Bhimad", "भिमाद", 9, "NP0440304", 0, []],
  ["L0440401", "D0440", 3, "Myagde", "म्याग्दे", 7, "NP0440401", 0, []],
  ["L0440402", "D0440", 3, "Ghiring", "घिरिङ", 5, "NP0440402", 0, []],
  ["L0440403", "D0440", 3, "Rhishing", "ऋषिङ्ग", 8, "NP0440403", 0, []],
  ["L0440404", "D0440", 3, "Bandipur", "बन्दिपुर", 6, "NP0440404", 0, []],
  ["L0440405", "D0440", 3, "Aanbu Khaireni", "आँबुखैरेनी", 6, "NP0440405", 0, []],
  ["L0440406", "D0440", 3, "Devghat", "देवघाट", 5, "NP0440406", 0, []],
  ["L0441301", "D0441", 2, "Putalibazar", "पुतलीबजार", 14, "NP0441301", 0, []],
  ["L0441302", "D0441", 2, "Bhirkot", "भीरकोट", 9, "NP0441302", 0, []],
  ["L0441303", "D0441", 2, "Galyang", "गल्याङ", 11, "NP0441303", 0, []],
  ["L0441304", "D0441", 2, "Walling", "वालिङ", 14, "NP0441304", 0, []],
  ["L0441305", "D0441", 2, "Chapakot", "चापाकोट", 10, "NP0441305", 0, []],
  ["L0441401", "D0441", 3, "Aandhikhola", "आँधिखोला", 6, "NP0441401", 0, []],
  ["L0441402", "D0441", 3, "Phedikhola", "फेदीखोला", 5, "NP0441402", 0, []],
  ["L0441403", "D0441", 3, "Arjun Choupari", "अर्जुनचौपारी", 6, "NP0441403", 0, []],
  ["L0441404", "D0441", 3, "Biruwa", "बिरुवा", 8, "NP0441404", 0, []],
  ["L0441405", "D0441", 3, "Harinas", "हरिनास", 7, "NP0441405", 0, []],
  ["L0441406", "D0441", 3, "Kaligandaki", "कालीगण्डकी", 7, "NP0441406", 0, []],
  ["L0442301", "D0442", 2, "Kushma", "कुश्मा", 14, "NP0442301", 0, []],
  ["L0442302", "D0442", 2, "Phalebas", "फलेवास", 11, "NP0442302", 0, []],
  ["L0442401", "D0442", 3, "Jaljala", "जलजला", 9, "NP0442401", 0, []],
  ["L0442402", "D0442", 3, "Modi", "मोदी", 8, "NP0442402", 0, []],
  ["L0442403", "D0442", 3, "Bihadi", "विहादी", 6, "NP0442403", 0, []],
  ["L0442404", "D0442", 3, "Mahashila", "महाशिला", 6, "NP0442404", 0, []],
  ["L0442405", "D0442", 3, "Paiyu", "पैयूं", 7, "NP0442405", 0, []],
  ["L0443301", "D0443", 2, "Dhorpatan", "ढोरपाटन", 9, "NP0443301", 0, []],
  ["L0443302", "D0443", 2, "Galkot", "गल्कोट", 11, "NP0443302", 0, []],
  ["L0443303", "D0443", 2, "Baglung", "बाग्लुङ", 14, "NP0443303", 0, []],
  ["L0443304", "D0443", 2, "Jaimuni", "जैमिनी", 10, "NP0443304", 0, []],
  ["L0443401", "D0443", 3, "Nisikhola", "निसीखोला", 7, "NP0443401", 0, []],
  ["L0443402", "D0443", 3, "Tamankhola", "तमानखोला", 6, "NP0443402", 0, []],
  ["L0443403", "D0443", 3, "Badigad", "वडिगाड", 10, "NP0443403", 0, []],
  ["L0443404", "D0443", 3, "Tarakhola", "ताराखोला", 5, "NP0443404", 0, []],
  ["L0443405", "D0443", 3, "Kathekhola", "काठेखोला", 8, "NP0443405", 0, []],
  ["L0443406", "D0443", 3, "Bareng", "वरेङ", 5, "NP0443406", 0, []],
  ["L0444301", "D0444", 2, "Beni", "बेनी", 10, "NP0444301", 0, []],
  ["L0444401", "D0444", 3, "Dhawalagiri", "", 7, "NP0444401", 0, []],
  ["L0444402", "D0444", 3, "Raghuganga", "रघुगंगा", 8, "NP0444402", 0, []],
  ["L0444403", "D0444", 3, "Annapurna", "अन्नपूर्ण", 8, "NP0444403", 0, []],
  ["L0444404", "D0444", 3, "Malika", "मालिका", 7, "NP0444404", 0, []],
  ["L0444405", "D0444", 3, "Mangala", "मंगला", 5, "NP0444405", 0, []],
  ["L0445401", "D0445", 3, "Lomanthang", "लोमन्थाङ", 5, "NP0445401", 0, []],
  ["L0445402", "D0445", 3, "Lo Ghekar Damodarkunda", "लो-घेकर दामोदरकुण्ड", 5, "NP0445402", 0, []],
  ["L0445403", "D0445", 3, "Varagung Muktichhetra", "वारागुङ मुक्तिक्षेत्र", 5, "NP0445403", 0, []],
  ["L0445404", "D0445", 3, "Gharpajhong", "घरपझोङ", 5, "NP0445404", 0, []],
  ["L0445405", "D0445", 3, "Thasang", "थासाङ", 5, "NP0445405", 0, []],
  ["L0447301", "D0447", 2, "Madhya Bindu", "मध्यविन्दु", 15, "NP0447301", 0, []],
  ["L0447302", "D0447", 2, "Kawasoti", "कावासोती", 17, "NP0447302", 0, []],
  ["L0447303", "D0447", 2, "Devchuli", "देवचुली", 17, "NP0447303", 0, []],
  ["L0447304", "D0447", 2, "Gaidakot", "गैंडाकोट", 18, "NP0447304", 0, []],
  ["L0447401", "D0447", 3, "Baudikali", "बौदीकाली", 6, "NP0447401", 0, []],
  ["L0447402", "D0447", 3, "Bulingtar", "बुलिङटार", 6, "NP0447402", 0, []],
  ["L0447403", "D0447", 3, "Hupsekot", "हुप्सेकोट", 6, "NP0447403", 0, []],
  ["L0447404", "D0447", 3, "Binayi Tribeni", "बिनयी त्रिवेणी", 7, "NP0447404", 0, []],
  ["L0546301", "D0546", 2, "Tansen", "तानसेन", 14, "NP0546301", 0, []],
  ["L0546302", "D0546", 2, "Rampur", "रामपुर", 10, "NP0546302", 0, []],
  ["L0546401", "D0546", 3, "Rainadevi Chhahara", "रैनादेवी छहरा", 8, "NP0546401", 0, []],
  ["L0546402", "D0546", 3, "Tinau", "तिनाउ", 6, "NP0546402", 0, []],
  ["L0546403", "D0546", 3, "Ribdikot", "रिब्दीकोट", 8, "NP0546403", 0, []],
  ["L0546404", "D0546", 3, "Mathagadhi", "माथागढी", 8, "NP0546404", 0, []],
  ["L0546405", "D0546", 3, "Baganaskali", "बगनासकाली", 9, "NP0546405", 0, []],
  ["L0546406", "D0546", 3, "Purbakhola", "पूर्वखोला", 6, "NP0546406", 0, []],
  ["L0546407", "D0546", 3, "Rambha", "रम्भा", 5, "NP0546407", 0, []],
  ["L0546408", "D0546", 3, "Nisdi", "निस्दी", 7, "NP0546408", 0, []],
  ["L0547301", "D0547", 2, "Sunawal", "सुनवल", 13, "NP0547301", 0, []],
  ["L0547302", "D0547", 2, "Bardaghat", "बर्दघाट", 16, "NP0547302", 0, []],
  ["L0547303", "D0547", 2, "Ramgram", "रामग्राम", 18, "NP0547303", 0, []],
  ["L0547401", "D0547", 3, "Palhinandan", "पाल्हीनन्दन", 6, "NP0547401", 0, []],
  ["L0547402", "D0547", 3, "Sarawal", "सरावल", 7, "NP0547402", 0, []],
  ["L0547403", "D0547", 3, "Pratapapur", "प्रतापपुर", 9, "NP0547403", 0, []],
  ["L0547404", "D0547", 3, "Susta", "सुस्ता", 5, "NP0547404", 0, []],
  ["L0548201", "D0548", 1, "Butwal", "बुटवल", 19, "NP0548201", 0, []],
  ["L0548301", "D0548", 2, "Sainamaina", "सैनामैना", 11, "NP0548301", 0, []],
  ["L0548302", "D0548", 2, "Devdaha", "देवदह", 12, "NP0548302", 0, []],
  ["L0548303", "D0548", 2, "Tilottama", "तिलोत्तमा", 17, "NP0548303", 0, []],
  ["L0548304", "D0548", 2, "Lumbini Sanskritik", "लुम्विनी सांस्कृतिक", 13, "NP0548304", 0, []],
  ["L0548305", "D0548", 2, "Siddharthanagar", "सिद्धार्थनगर", 13, "NP0548305", 0, []],
  ["L0548401", "D0548", 3, "Kanchan", "कन्चन", 5, "NP0548401", 0, []],
  ["L0548402", "D0548", 3, "Suddhodhan", "शुद्धोधन", 7, "NP0548402", 0, []],
  ["L0548403", "D0548", 3, "Gaidahawa", "गैडहवा", 9, "NP0548403", 0, []],
  ["L0548404", "D0548", 3, "Siyari", "सियारी", 7, "NP0548404", 0, []],
  ["L0548405", "D0548", 3, "Mayadevi", "मायादेवी", 8, "NP0548405", 0, []],
  ["L0548406", "D0548", 3, "Om Satiya", "ओमसतिया", 6, "NP0548406", 0, []],
  ["L0548407", "D0548", 3, "Rohini", "रोहिणी", 7, "NP0548407", 0, []],
  ["L0548408", "D0548", 3, "Kotahimai", "कोटहीमाई", 7, "NP0548408", 0, []],
  ["L0548409", "D0548", 3, "Sammarimai", "सम्मरीमाई", 7, "NP0548409", 0, []],
  ["L0548410", "D0548", 3, "Marchawari", "मर्चवारी", 7, "NP0548410", 0, []],
  ["L0549301", "D0549", 2, "Shivaraj", "शिवराज", 11, "NP0549301", 0, []],
  ["L0549302", "D0549", 2, "Buddhabhumi", "बुद्धभुमी", 10, "NP0549302", 0, []],
  ["L0549303", "D0549", 2, "Banganga", "बाणगंगा", 11, "NP0549303", 0, []],
  ["L0549304", "D0549", 2, "Krishnanagar", "कृष्णनगर", 12, "NP0549304", 0, []],
  ["L0549305", "D0549", 2, "Maharajganj", "महाराजगञ्ज", 11, "NP0549305", 0, []],
  ["L0549306", "D0549", 2, "Kapilbastu", "कपिलवस्तु", 12, "NP0549306", 0, []],
  ["L0549401", "D0549", 3, "Bijayanagar", "विजयनगर", 7, "NP0549401", 0, []],
  ["L0549402", "D0549", 3, "Yasodhara", "यसोधरा", 8, "NP0549402", 0, []],
  ["L0549403", "D0549", 3, "Mayadevi", "मायादेवी", 8, "NP0549403", 0, []],
  ["L0549404", "D0549", 3, "Shuddhodhan", "शुद्धोधन", 6, "NP0549404", 0, []],
  ["L0550301", "D0550", 2, "Bhumikasthan", "भुमिकास्थान", 10, "NP0550301", 0, []],
  ["L0550302", "D0550", 2, "Sandhikharka", "सन्धिखर्क", 12, "NP0550302", 0, []],
  ["L0550303", "D0550", 2, "Shitaganga", "शितगंगा", 14, "NP0550303", 0, []],
  ["L0550401", "D0550", 3, "Malarani", "मालारानी", 9, "NP0550401", 0, []],
  ["L0550402", "D0550", 3, "Chhatradev", "छत्रदेव", 8, "NP0550402", 0, []],
  ["L0550403", "D0550", 3, "Panini", "पाणिनी", 8, "NP0550403", 0, []],
  ["L0551301", "D0551", 2, "Musikot", "मुसिकोट", 9, "NP0551301", 0, []],
  ["L0551302", "D0551", 2, "Resunga", "रेसुंगा", 14, "NP0551302", 0, []],
  ["L0551401", "D0551", 3, "Madane", "मदाने", 7, "NP0551401", 0, []],
  ["L0551402", "D0551", 3, "Malika", "मालिका", 8, "NP0551402", 0, []],
  ["L0551403", "D0551", 3, "Dhurkot", "धुर्कोट", 7, "NP0551403", 0, []],
  ["L0551404", "D0551", 3, "Isma", "इस्मा", 6, "NP0551404", 0, []],
  ["L0551405", "D0551", 3, "Gulmi Durbar", "गुल्मीदरबार", 7, "NP0551405", 0, []],
  ["L0551406", "D0551", 3, "Chandrakot", "चन्द्रकोट", 8, "NP0551406", 0, []],
  ["L0551407", "D0551", 3, "Chhatrakot", "छत्रकोट", 6, "NP0551407", 0, []],
  ["L0551408", "D0551", 3, "Ruruchhetra", "रुरुक्षेत्र", 6, "NP0551408", 0, []],
  ["L0551409", "D0551", 3, "Satyawoti", "सत्यवती", 8, "NP0551409", 0, []],
  ["L0551410", "D0551", 3, "Kali Gandaki", "कालीगण्डकी", 7, "NP0551410", 0, []],
  ["L0552401", "D0552", 3, "Sisne", "सिस्ने", 8, "NP0552401", 0, []],
  ["L0552402", "D0552", 3, "Putha Uttanganga", "पुथा उत्तरगंगा", 14, "NP0552402", 0, []],
  ["L0552403", "D0552", 3, "Bhoome", "भूमे", 9, "NP0552403", 0, []],
  ["L0554301", "D0554", 2, "Rolpa", "रोल्पा", 10, "NP0554301", 0, []],
  ["L0554401", "D0554", 3, "Gangadev", "गंगादेव", 7, "NP0554401", 0, []],
  ["L0554402", "D0554", 3, "Pariwartan", "परिवर्तन", 6, "NP0554402", 0, []],
  ["L0554403", "D0554", 3, "Thawang", "थवाङ", 5, "NP0554403", 0, []],
  ["L0554404", "D0554", 3, "Madi", "माडी", 6, "NP0554404", 0, []],
  ["L0554405", "D0554", 3, "Sunchhahari", "सुनछहरी", 7, "NP0554405", 0, []],
  ["L0554406", "D0554", 3, "Tribeni", "त्रिवेणी", 7, "NP0554406", 0, []],
  ["L0554407", "D0554", 3, "Sunil Smriti", "सुनिल स्मृति", 8, "NP0554407", 0, []],
  ["L0554408", "D0554", 3, "Lungri", "लुङग्री", 7, "NP0554408", 0, []],
  ["L0554409", "D0554", 3, "Runtigadhi", "रुन्टीगढी", 9, "NP0554409", 0, []],
  ["L0555301", "D0555", 2, "Sworgadwari", "स्वर्गद्वारी", 9, "NP0555301", 0, []],
  ["L0555302", "D0555", 2, "Pyuthan", "प्यूठान", 10, "NP0555302", 0, []],
  ["L0555401", "D0555", 3, "Naubahini", "नौबहिनी", 8, "NP0555401", 0, []],
  ["L0555402", "D0555", 3, "Gaumukhi", "गौमुखी", 7, "NP0555402", 0, []],
  ["L0555403", "D0555", 3, "Jhimaruk", "झिमरुक", 8, "NP0555403", 0, []],
  ["L0555404", "D0555", 3, "Mandavi", "माण्डवी", 5, "NP0555404", 0, []],
  ["L0555405", "D0555", 3, "Mallarani", "मल्लरानी", 5, "NP0555405", 0, []],
  ["L0555406", "D0555", 3, "Sarumarani", "सरुमारानी", 6, "NP0555406", 0, []],
  ["L0555407", "D0555", 3, "Aairawati", "ऐरावती", 6, "NP0555407", 0, []],
  ["L0556201", "D0556", 1, "Tulsipur", "तुल्सीपुर", 19, "NP0556201", 0, []],
  ["L0556202", "D0556", 1, "Ghorahi", "घोराही", 19, "NP0556202", 0, []],
  ["L0556301", "D0556", 2, "Lamahi", "लमही", 9, "NP0556301", 0, []],
  ["L0556401", "D0556", 3, "Babai", "बबई", 7, "NP0556401", 0, []],
  ["L0556402", "D0556", 3, "Dangisharan", "दंगीशरण", 7, "NP0556402", 0, []],
  ["L0556403", "D0556", 3, "Shantinagar", "शान्तिनगर", 7, "NP0556403", 0, []],
  ["L0556404", "D0556", 3, "Rajpur", "राजपुर", 7, "NP0556404", 0, []],
  ["L0556405", "D0556", 3, "Bangalachuli", "बंगलाचुली", 8, "NP0556405", 0, []],
  ["L0556406", "D0556", 3, "Gadhawa", "गढवा", 8, "NP0556406", 0, []],
  ["L0556407", "D0556", 3, "Rapti", "राप्ती", 9, "NP0556407", 0, []],
  ["L0557201", "D0557", 1, "Nepalganj", "नेपालगञ्ज", 23, "NP0557201", 0, []],
  ["L0557301", "D0557", 2, "Kohalpur", "कोहलपुर", 15, "NP0557301", 0, []],
  ["L0557401", "D0557", 3, "Khajura", "खजुरा", 8, "NP0557401", 0, []],
  ["L0557402", "D0557", 3, "Baijanath", "बैजनाथ", 8, "NP0557402", 0, []],
  ["L0557403", "D0557", 3, "Janaki", "जानकी", 6, "NP0557403", 0, []],
  ["L0557404", "D0557", 3, "Duduwa", "डुडुवा", 6, "NP0557404", 0, []],
  ["L0557405", "D0557", 3, "Rapti Sonari", "राप्तीसोनारी", 9, "NP0557405", 0, []],
  ["L0557406", "D0557", 3, "Narainapur", "नरैनापुर", 6, "NP0557406", 0, []],
  ["L0558301", "D0558", 2, "Rajapur", "राजापुर", 10, "NP0558301", 0, []],
  ["L0558302", "D0558", 2, "Madhuwan", "मधुवन", 9, "NP0558302", 0, []],
  ["L0558303", "D0558", 2, "Thakurbaba", "ठाकुरबाबा", 9, "NP0558303", 0, []],
  ["L0558304", "D0558", 2, "Gulariya", "गुलरिया", 12, "NP0558304", 0, []],
  ["L0558305", "D0558", 2, "Barbardiya", "बारबर्दिया", 11, "NP0558305", 0, []],
  ["L0558306", "D0558", 2, "Bansgadhi", "बाँसगढी", 9, "NP0558306", 0, []],
  ["L0558401", "D0558", 3, "Geruwa", "गेरुवा", 6, "NP0558401", 0, []],
  ["L0558402", "D0558", 3, "Badhaiyatal", "बढैयाताल", 9, "NP0558402", 0, []],
  ["L0652301", "D0652", 2, "Aathabisakot", "आठबिसकोट", 14, "NP0652301", 0, []],
  ["L0652302", "D0652", 2, "Chaurjahari", "चौरजहारी", 14, "NP0652302", 0, []],
  ["L0652303", "D0652", 2, "Musikot", "मुसिकोट", 14, "NP0652303", 0, []],
  ["L0652401", "D0652", 3, "Sanibheri", "सानीभेरी", 11, "NP0652401", 0, []],
  ["L0652402", "D0652", 3, "Banphikot", "बाँफिकोट", 10, "NP0652402", 0, []],
  ["L0652403", "D0652", 3, "Tribeni", "त्रिवेणी", 10, "NP0652403", 0, []],
  ["L0653301", "D0653", 2, "Banagad Kupinde", "बनगाँड कुपिण्डे", 12, "NP0653301", 0, []],
  ["L0653302", "D0653", 2, "Bagachour", "बागचौर", 12, "NP0653302", 0, []],
  ["L0653303", "D0653", 2, "Sharada", "शारदा", 15, "NP0653303", 0, []],
  ["L0653401", "D0653", 3, "Kumakh", "कुमाख", 7, "NP0653401", 0, []],
  ["L0653402", "D0653", 3, "Darma", "दार्मा", 6, "NP0653402", 0, []],
  ["L0653403", "D0653", 3, "Siddha Kumakh", "सिद्ध कुमाख", 5, "NP0653403", 0, []],
  ["L0653404", "D0653", 3, "Kalimati", "कालिमाटी", 7, "NP0653404", 0, []],
  ["L0653405", "D0653", 3, "Chhatreshwori", "छत्रेश्वरी", 7, "NP0653405", 0, []],
  ["L0653406", "D0653", 3, "Tribeni", "त्रिवेणी", 6, "NP0653406", 0, []],
  ["L0653407", "D0653", 3, "Kapurkot", "कपुरकोट", 6, "NP0653407", 0, []],
  ["L0659301", "D0659", 2, "Panchapuri", "पञ्चपुरी", 11, "NP0659301", 0, []],
  ["L0659302", "D0659", 2, "Bheriganga", "भेरीगंगा", 13, "NP0659302", 0, []],
  ["L0659303", "D0659", 2, "Birendranagar", "बीरेन्द्रनगर", 16, "NP0659303", 0, []],
  ["L0659304", "D0659", 2, "Lekabeshi", "लेकबेसी", 10, "NP0659304", 0, []],
  ["L0659305", "D0659", 2, "Gurbhakot", "गुर्भाकोट", 14, "NP0659305", 0, []],
  ["L0659401", "D0659", 3, "Chaukune", "चौकुने", 10, "NP0659401", 0, []],
  ["L0659402", "D0659", 3, "Barahatal", "बराहताल", 10, "NP0659402", 0, []],
  ["L0659403", "D0659", 3, "Chingad", "चिङ्गाड", 6, "NP0659403", 0, []],
  ["L0659404", "D0659", 3, "Simta", "सिम्ता", 9, "NP0659404", 0, []],
  ["L0660301", "D0660", 2, "Chhedagad", "छेडागाड", 13, "NP0660301", 0, []],
  ["L0660302", "D0660", 2, "Bheri Malika", "भेरी", 13, "NP0660302", 0, []],
  ["L0660303", "D0660", 2, "Nalgad", "नलगाड", 13, "NP0660303", 0, []],
  ["L0660401", "D0660", 3, "Junichande", "जुनीचाँदे", 11, "NP0660401", 0, []],
  ["L0660402", "D0660", 3, "Kuse", "कुसे", 9, "NP0660402", 0, []],
  ["L0660403", "D0660", 3, "Barekot", "बारेकोट", 9, "NP0660403", 0, []],
  ["L0660404", "D0660", 3, "Shivalaya", "शिवालय", 9, "NP0660404", 0, []],
  ["L0661301", "D0661", 2, "Aathbis", "आठबीस", 9, "NP0661301", 0, []],
  ["L0661302", "D0661", 2, "Chamunda Bindrasaini", "चामुण्डा बिन्द्रासैनी", 9, "NP0661302", 0, []],
  ["L0661303", "D0661", 2, "Dullu", "दुल्लु", 13, "NP0661303", 0, []],
  ["L0661304", "D0661", 2, "Narayan", "नारायण", 11, "NP0661304", 0, []],
  ["L0661401", "D0661", 3, "Thantikandh", "ठाँटीकाँध", 6, "NP0661401", 0, []],
  ["L0661402", "D0661", 3, "Bhairabi", "भैरवी", 7, "NP0661402", 0, []],
  ["L0661403", "D0661", 3, "Mahabu", "महाबु", 6, "NP0661403", 0, []],
  ["L0661404", "D0661", 3, "Naumule", "नौमुले", 8, "NP0661404", 0, []],
  ["L0661405", "D0661", 3, "Gurans", "गुराँस", 8, "NP0661405", 0, []],
  ["L0661406", "D0661", 3, "Dungeshwor", "डुंगेश्वर", 6, "NP0661406", 0, []],
  ["L0661407", "D0661", 3, "Bhagawatimai", "भगवतीमाई", 7, "NP0661407", 0, []],
  ["L0662301", "D0662", 2, "Tripurasundari", "त्रिपुरासुन्दरी", 11, "NP0662301", 0, []],
  ["L0662302", "D0662", 2, "Thulibheri", "ठूलीभेरी", 11, "NP0662302", 0, []],
  ["L0662401", "D0662", 3, "Shey Phoksundo", "शे फोक्सुन्डो", 9, "NP0662401", 0, []],
  ["L0662402", "D0662", 3, "Jagadulla", "जगदुल्ला", 6, "NP0662402", 0, []],
  ["L0662403", "D0662", 3, "Dolpo Buddha", "डोल्पो बुद्ध", 6, "NP0662403", 0, []],
  ["L0662404", "D0662", 3, "Mudkechula", "मुड्केचुला", 9, "NP0662404", 0, []],
  ["L0662405", "D0662", 3, "Kaike", "काईके", 7, "NP0662405", 0, []],
  ["L0662406", "D0662", 3, "Chharka Tangsong", "छार्का ताङसोङ", 6, "NP0662406", 0, []],
  ["L0663301", "D0663", 2, "Chandannath", "चन्दननाथ", 10, "NP0663301", 0, []],
  ["L0663401", "D0663", 3, "Kanaka Sundari", "कनकासुन्दरी", 8, "NP0663401", 0, []],
  ["L0663402", "D0663", 3, "Sinja", "सिंजा", 6, "NP0663402", 0, []],
  ["L0663403", "D0663", 3, "Patarasi", "पातारासी", 7, "NP0663403", 0, []],
  ["L0663404", "D0663", 3, "Hima", "हिमा", 7, "NP0663404", 0, []],
  ["L0663405", "D0663", 3, "Tila", "तिला", 9, "NP0663405", 0, []],
  ["L0663406", "D0663", 3, "Tatopani", "तातोपानी", 8, "NP0663406", 0, []],
  ["L0663407", "D0663", 3, "Guthichaur", "गुठिचौर", 5, "NP0663407", 0, []],
  ["L0664301", "D0664", 2, "Raskot", "रास्कोट", 9, "NP0664301", 0, []],
  ["L0664302", "D0664", 2, "Khandachakra", "खाँडाचक्र", 11, "NP0664302", 0, []],
  ["L0664303", "D0664", 2, "Tilagupha", "तिलागुफा", 11, "NP0664303", 0, []],
  ["L0664401", "D0664", 3, "Naraharinath", "नरहरिनाथ", 9, "NP0664401", 0, []],
  ["L0664402", "D0664", 3, "Sanni Tribeni", "सान्नी त्रिवेणी", 9, "NP0664402", 0, []],
  ["L0664403", "D0664", 3, "Pachal Jharana", "", 9, "NP0664403", 0, []],
  ["L0664404", "D0664", 3, "Palata", "पलाता", 9, "NP0664404", 0, []],
  ["L0664405", "D0664", 3, "Shuva Kalika", "शुभ कालिका", 8, "NP0664405", 0, []],
  ["L0664406", "D0664", 3, "Mahawai", "महावै", 7, "NP0664406", 0, []],
  ["L0665301", "D0665", 2, "Chhayanath Rara", "छायाँनाथ रारा", 14, "NP0665301", 0, []],
  ["L0665401", "D0665", 3, "Khatyad", "खत्याड", 11, "NP0665401", 0, []],
  ["L0665402", "D0665", 3, "Soru", "सोरु", 11, "NP0665402", 0, []],
  ["L0665403", "D0665", 3, "Mugumakarmarog", "मुगुमकार्मारोंग", 9, "NP0665403", 0, []],
  ["L0666401", "D0666", 3, "Namkha", "नाम्खा", 6, "NP0666401", 0, []],
  ["L0666402", "D0666", 3, "Simkot", "सिमकोट", 8, "NP0666402", 0, []],
  ["L0666403", "D0666", 3, "Kharpunath", "खार्पुनाथ", 5, "NP0666403", 0, []],
  ["L0666404", "D0666", 3, "Sarkegad", "सर्केगाड", 8, "NP0666404", 0, []],
  ["L0666405", "D0666", 3, "Chankheli", "चंखेली", 6, "NP0666405", 0, []],
  ["L0666406", "D0666", 3, "Tanjakot", "ताँजाकोट", 5, "NP0666406", 0, []],
  ["L0666407", "D0666", 3, "Adanchuli", "", 6, "NP0666407", 0, []],
  ["L0767301", "D0767", 2, "Bungal", "बुंगल", 11, "NP0767301", 0, []],
  ["L0767302", "D0767", 2, "Jayaprithbi", "जयपृथ्वी", 11, "NP0767302", 0, []],
  ["L0767401", "D0767", 3, "Saipal", "साईपाल", 5, "NP0767401", 0, []],
  ["L0767402", "D0767", 3, "Surma", "", 5, "NP0767402", 0, []],
  ["L0767403", "D0767", 3, "Talkot", "तालकोट", 7, "NP0767403", 0, []],
  ["L0767404", "D0767", 3, "Bitthadchir", "", 9, "NP0767404", 0, []],
  ["L0767405", "D0767", 3, "Kedarsyun", "केदारस्युँ", 9, "NP0767405", 0, []],
  ["L0767406", "D0767", 3, "Durgathali", "दुर्गाथली", 7, "NP0767406", 0, []],
  ["L0767407", "D0767", 3, "Chhabis Pathibhara", "छबिसपाथिभेरा", 7, "NP0767407", 0, []],
  ["L0767408", "D0767", 3, "Masta", "मष्टा", 7, "NP0767408", 0, []],
  ["L0767409", "D0767", 3, "Thalara", "थलारा", 9, "NP0767409", 0, []],
  ["L0767410", "D0767", 3, "Khaptad Chhanna", "खप्तडछान्ना", 7, "NP0767410", 0, []],
  ["L0768301", "D0768", 2, "Budhinanda", "", 10, "NP0768301", 0, []],
  ["L0768302", "D0768", 2, "Badimalika", "बडिमालिका", 9, "NP0768302", 0, []],
  ["L0768303", "D0768", 2, "Budhiganga", "बुढीगंगा", 10, "NP0768303", 0, []],
  ["L0768304", "D0768", 2, "Tribeni", "त्रिवेणी", 9, "NP0768304", 0, []],
  ["L0768401", "D0768", 3, "Himali", "हिमाली", 7, "NP0768401", 0, []],
  ["L0768402", "D0768", 3, "Gaumul", "गौमुल", 6, "NP0768402", 0, []],
  ["L0768403", "D0768", 3, "Khaptad Chhededaha", "खप्तड छेडेदह", 7, "NP0768403", 0, []],
  ["L0768404", "D0768", 3, "Jagannath", "जगन्नाथ", 6, "NP0768404", 0, []],
  ["L0768405", "D0768", 3, "Swamikartik Khapar", "स्वामीकार्तिक खापर", 5, "NP0768405", 0, []],
  ["L0769301", "D0769", 2, "Sanphebagar", "साँफेवगर", 14, "NP0769301", 0, []],
  ["L0769302", "D0769", 2, "Mangalsen", "मंगलसेन", 14, "NP0769302", 0, []],
  ["L0769303", "D0769", 2, "Kamal bazar", "कमलबजार", 10, "NP0769303", 0, []],
  ["L0769304", "D0769", 2, "Panchdebal Binayak", "पंचदेवल विनायक", 9, "NP0769304", 0, []],
  ["L0769401", "D0769", 3, "Chaurpati", "चौरपाटी", 7, "NP0769401", 0, []],
  ["L0769402", "D0769", 3, "Mellekh", "मेल्लेख", 8, "NP0769402", 0, []],
  ["L0769403", "D0769", 3, "Bannigadhi Jayagadh", "बान्नीगढी जयगढ", 6, "NP0769403", 0, []],
  ["L0769404", "D0769", 3, "Ramaroshan", "रामारोशन", 7, "NP0769404", 0, []],
  ["L0769405", "D0769", 3, "Dhakari", "ढकारी", 8, "NP0769405", 0, []],
  ["L0769406", "D0769", 3, "Turmakhand", "", 8, "NP0769406", 0, []],
  ["L0770301", "D0770", 2, "Shikhar", "शिखर", 11, "NP0770301", 0, []],
  ["L0770302", "D0770", 2, "Dipayal Silgadhi", "दिपायल सिलगढी", 9, "NP0770302", 0, []],
  ["L0770401", "D0770", 3, "Aadarsha", "आदर्श", 7, "NP0770401", 0, []],
  ["L0770402", "D0770", 3, "Sayal", "सायल", 6, "NP0770402", 0, []],
  ["L0770403", "D0770", 3, "Purbichouki", "पूर्वीचौकी", 7, "NP0770403", 0, []],
  ["L0770404", "D0770", 3, "Jorayal", "जोरायल", 6, "NP0770404", 0, []],
  ["L0770405", "D0770", 3, "K.I. Singh", "के.आई.सिंह", 7, "NP0770405", 0, []],
  ["L0770406", "D0770", 3, "Badi Kedar", "बडीकेदार", 5, "NP0770406", 0, []],
  ["L0770407", "D0770", 3, "Bogatan Phudsil", "बोगटान फुड्सिल", 7, "NP0770407", 0, []],
  ["L0771201", "D0771", 1, "Dhangadhi", "धनगढी", 19, "NP0771201", 0, []],
  ["L0771301", "D0771", 2, "Godawari", "गोदावरी", 12, "NP0771301", 0, []],
  ["L0771302", "D0771", 2, "Gauriganga", "गौरीगंगा", 11, "NP0771302", 0, []],
  ["L0771303", "D0771", 2, "Ghodaghodi", "घोडाघोडी", 12, "NP0771303", 0, []],
  ["L0771304", "D0771", 2, "Bhajani", "भजनी", 9, "NP0771304", 0, []],
  ["L0771305", "D0771", 2, "Tikapur", "टिकापुर", 9, "NP0771305", 0, []],
  ["L0771306", "D0771", 2, "Lamki Chuha", "लम्किचुहा", 10, "NP0771306", 0, []],
  ["L0771401", "D0771", 3, "Chure", "चुरे", 6, "NP0771401", 0, []],
  ["L0771402", "D0771", 3, "Kailari", "कैलारी", 9, "NP0771402", 0, []],
  ["L0771403", "D0771", 3, "Mohanyal", "मोहन्याल", 7, "NP0771403", 0, []],
  ["L0771404", "D0771", 3, "Joshipur", "जोशीपुर", 7, "NP0771404", 0, []],
  ["L0771405", "D0771", 3, "Bardagoriya", "बर्दगोरिया", 6, "NP0771405", 0, []],
  ["L0771406", "D0771", 3, "Janaki", "जानकी", 9, "NP0771406", 0, []],
  ["L0772301", "D0772", 2, "Dodhara Chandani", "दोधारा चाँदनी", 10, "NP0772301", 0, []],
  ["L0772302", "D0772", 2, "Bhimdatta", "भिमदत्त", 19, "NP0772302", 0, []],
  ["L0772303", "D0772", 2, "Bedkot", "बेदकोट", 10, "NP0772303", 0, []],
  ["L0772304", "D0772", 2, "Shuklaphanta", "शुक्लाफाँट", 12, "NP0772304", 0, []],
  ["L0772305", "D0772", 2, "Krishnapur", "कृष्णपुर", 9, "NP0772305", 0, []],
  ["L0772306", "D0772", 2, "Belouri", "बेलौरी", 10, "NP0772306", 0, []],
  ["L0772307", "D0772", 2, "Punarbas", "पुनर्वास", 11, "NP0772307", 0, []],
  ["L0772401", "D0772", 3, "Beldandi", "बेलडाँडी", 5, "NP0772401", 0, []],
  ["L0772402", "D0772", 3, "Laljhadi", "लालझाडी", 6, "NP0772402", 0, []],
  ["L0773301", "D0773", 2, "Parashuram", "परशुराम", 12, "NP0773301", 0, []],
  ["L0773302", "D0773", 2, "Amargadhi", "अमरगढी", 11, "NP0773302", 0, []],
  ["L0773401", "D0773", 3, "Bhageshwor", "भागेश्वर", 5, "NP0773401", 0, []],
  ["L0773402", "D0773", 3, "Ajayameru", "अजयमेरु", 6, "NP0773402", 0, []],
  ["L0773403", "D0773", 3, "Nawadurga", "नवदुर्गा", 5, "NP0773403", 0, []],
  ["L0773404", "D0773", 3, "Aalital", "आलिताल", 8, "NP0773404", 0, []],
  ["L0773405", "D0773", 3, "Ganyapdhura", "गन्यापधुरा", 5, "NP0773405", 0, []],
  ["L0774301", "D0774", 2, "Dasharathchand", "दशरथचन्द", 11, "NP0774301", 0, []],
  ["L0774302", "D0774", 2, "Puchaundi", "पुर्चौडी", 10, "NP0774302", 0, []],
  ["L0774303", "D0774", 2, "Melauli", "मेलौली", 9, "NP0774303", 0, []],
  ["L0774304", "D0774", 2, "Patan", "पाटन", 10, "NP0774304", 0, []],
  ["L0774401", "D0774", 3, "Dilasaini", "", 7, "NP0774401", 0, []],
  ["L0774402", "D0774", 3, "Dogada Kedar", "दोगडाकेदार", 8, "NP0774402", 0, []],
  ["L0774403", "D0774", 3, "Surnaya", "", 8, "NP0774403", 0, []],
  ["L0774404", "D0774", 3, "Pancheshwor", "पंचेश्वर", 6, "NP0774404", 0, []],
  ["L0774405", "D0774", 3, "Shivanath", "शिवनाथ", 6, "NP0774405", 0, []],
  ["L0774406", "D0774", 3, "Sigas", "सिगास", 9, "NP0774406", 0, []],
  ["L0775301", "D0775", 2, "Mahakali", "महाकाली", 9, "NP0775301", 0, []],
  ["L0775302", "D0775", 2, "Shailyashikhar", "शैल्यशिखर", 9, "NP0775302", 0, []],
  ["L0775401", "D0775", 3, "Byas", "व्याँस", 6, "NP0775401", 0, []],
  ["L0775402", "D0775", 3, "Duhun", "दुहुँ", 5, "NP0775402", 0, []],
  ["L0775403", "D0775", 3, "Apihimal", "अपिहिमाल", 6, "NP0775403", 0, []],
  ["L0775404", "D0775", 3, "Malikarjun", "मालिकार्जुन", 8, "NP0775404", 0, []],
  ["L0775405", "D0775", 3, "Naugad", "नौगाड", 6, "NP0775405", 0, []],
  ["L0775406", "D0775", 3, "Lekam", "लेकम", 6, "NP0775406", 0, []],
  ["L0775407", "D0775", 3, "Marma", "मार्मा", 6, "NP0775407", 0, []],
];

/** [code, name, kind, status, basis, member local-level codes] */
export const ZONE_ROWS: readonly (readonly [
  string,
  string,
  string,
  string,
  string,
  readonly string[],
])[] = [
  [
    "ktm_valley",
    "Kathmandu Valley",
    "valley",
    "inferred",
    "All local levels of Kathmandu, Lalitpur and Bhaktapur districts except Lalitpur's Bagmati, Mahankal and Konjyosom rural municipalities (south of the valley rim). Owner review required.",
    [
      "L0325101",
      "L0325301",
      "L0325302",
      "L0326301",
      "L0326302",
      "L0326303",
      "L0326304",
      "L0327101",
      "L0327301",
      "L0327302",
      "L0327303",
      "L0327304",
      "L0327305",
      "L0327306",
      "L0327307",
      "L0327308",
      "L0327309",
      "L0327310",
    ],
  ],
  [
    "ktm_ring_road",
    "Inside Kathmandu Ring Road",
    "ring_road",
    "gap",
    "Needs ward-level membership (the ring road splits metropolitan cities). No official ward list found yet; members empty.",
    [],
  ],
];

/** [courier, area_code, area_name, branch, local_level_code | "", confidence, version] (stub until courier data arrives) */
export const COURIER_AREA_ROWS: readonly (readonly [
  string,
  string,
  string,
  string,
  string,
  string,
  string,
])[] = [];
